export const clientIds = {
  nwPredictorClientId: 'nw_predictor',
  nwPredictorClgPrepClientId: 'nw_predictor_clg_prep',
  nwPredictorClgYaarClientId: 'nw_predictor_clg_yaar',
  nwPredictorClgPickerClientId: 'nw_predictor_clg_picker',
  abroadDostClientId: 'abroad_dost',
  otgFormsClientId: 'otg_forms',
  guidexpertPayoutsClientId: 'guidexpert_payouts'
};
